import { useNavigate } from 'react-router-dom'

import Marquee from '../Marquee/Marquee'
import styles from './Contact.module.scss'

function Contact({ marquees }) {
  const navigate = useNavigate()
  const contactClickHandler = (marquee) => {
    navigate(`${marquee?.path}?form=open` || '/')
  }

  return (
    <Marquee duration={1} className={styles.container}>
      <div className={styles.marqueeContainer}>
        {marquees.map((marquee) => (
          <span
            key={'marquee' + marquee?.id}
            className={styles.marquee}
            // onClick={(e) => contactClickHandler(marquee)}
          >
            {marquee.label}
          </span>
        ))}
      </div>
    </Marquee>
  )
}

export default Contact
